var _Path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgIndicatorRemove = function SvgIndicatorRemove(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    overflow: "visible",
    preserveAspectRatio: "none",
    style: {
      display: "block"
    },
    viewBox: "0 0 12 12"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    stroke: "#D9C4BC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.3,
    d: "m3.5 3.5 5 5m0-5-5 5"
  })));
};
export default SvgIndicatorRemove;